module.exports = __webpack_public_path__ + "img/chf.8311dc20.svg";